import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import mwButtonSchema from './schema.json';

export default class MwButton extends Component {
  @tracked size = 'm';
  @tracked variant = 'primary';
  @tracked disabled = false;
  @tracked inProgress = false;
  @tracked transparent = false;
  @tracked icon = 'card';
  @tracked iconSize = '24 (default)';
  @tracked label = 'Confirm';

  // Component schema for universal builder
  get componentSchema() {
    return mwButtonSchema;
  }

  @action
  setSize(size) {
    this.size = size;
  }

  @action
  setVariant(variant) {
    this.variant = variant;
  }

  @action
  setIcon(icon) {
    this.icon = icon;
  }

  @action
  setIconSize(iconSize) {
    this.iconSize = iconSize;
  }
}
